import React from 'react';

import {Create} from 'react-admin';

import CampaignChallengeForm from "./CampaignChallengeForm";

const CampaignChallengeCreate = (props) => (
    <Create {...props}><CampaignChallengeForm/></Create>
);

export default CampaignChallengeCreate;
